import React, { useContext, useState } from "react";
import {
  View,
  Text,
  Image,
  Pressable,
  TouchableOpacity,
  Dimensions,
  Platform,
} from "react-native";
import { useColorScheme } from "react-native-appearance";
import { colors } from "../context/Colors";
import AppContext from "../context";
import GameFooter from "./GameFooter";
import GameDescription from "./GameDescription";
import Icon from "react-native-vector-icons/Ionicons";
// import { useNavigation } from "@react-navigation/native";

const calcSize = () => {
  const width = Dimensions.get("screen").width;
  if (width > 700) {
    return width / 4 - 30;
  } else {
    return width / 2 - 30;
  }
};

export default function FindObject({ g, current, answer }) {
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const { tour, setTour, dict, checkOnlineState } = useContext(AppContext);
  const size = calcSize();
  // const navigation = useNavigation();
  const takePhoto = (a) => {
    if (g.state === "failed" || g.state === "correct") {
    } else {
      // if (checkOnlineState()) {
      // navigation.navigate("Camera", {
      //   g,
      // });
      // }
    }
  };

  if (Platform.OS === "web")
    return (
      <Text
        style={{
          fontSize: 18,
          fontWeight: "bold",
          color: colors[theme].text,
          marginTop: 30,
          textAlign: "center",
        }}
      >
        {dict.photo_not_supported}
      </Text>
    );

  return (
    <View>
      <GameDescription g={g} current={current} />

      {g.state !== "failed" && g.state !== "correct" ? (
        <>
          <View style={{ height: 60 }} />
          <View style={{ justifyContent: "center", alignItems: "center" }}>
            <TouchableOpacity
              style={{
                borderRadius: 4,
                padding: 12,
                marginBottom: 20,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                borderColor: colors[theme].gray2,
                borderWidth: 2,
                display: g.state === "correct" ? "none" : "flex",
                width: size * 2 + 20,
              }}
              onPress={() => takePhoto()}
              disabled={g.state === "correct"}
            >
              <Icon name="scan-outline" size={30} color={colors[theme].text} />
              <Text
                style={{
                  color: colors[theme].text,
                  fontWeight: "500",
                  marginLeft: 7,
                  fontSize: 18,
                }}
              >
                {dict.magic_scanner_button}
              </Text>
            </TouchableOpacity>
          </View>
        </>
      ) : null}

      <GameFooter g={g} size={size} />
      {/* <View
        style={{
          backgroundColor: '#F4E3E3',
          padding: 15,
          borderRadius: 10,
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          marginVertical: 40
        }}
      >
        <Image
          source={require('../assets/repairing-service.png')}
          style={{
            width: 40,
            height: 40,
            marginRight: 20
          }}
        />
        <Text
          style={{ color: '#DD4D4D', fontWeight: '600', fontSize: 16, flex: 1 }}
        >
          {dict.magic_scanner}
        </Text>
      </View> */}
    </View>
  );
}
